import {
  CrewImage,
  EnterButton,
  HomeStyle,
  LoginCard,
  LoginField,
  SesiImage,
  SesiImageWrapper,
  StaticImage,
  VersionNumber,
  WrapContent,
  WrapContentLoginCard,
} from "../../styles/Home";
import BACKGROUNDIMAGE from "../../assets/img/backgroundImage.png";
import SESI from "../../assets/img/sesi.png";
import CREW from "../../assets/img/crew.png";
import { CREW_LOGIN, HOME_LOGGED, PREREGISTER, SELECTEMAIL } from "../../core/app-urls";
import { version } from "../../utils/constants";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { cnpj, enterpriseAuth, setCnpj } from "../../data/services/enterprise_service";
import { FaEye, FaEyeSlash } from "react-icons/fa";

export default function Home() {
  const navigate = useNavigate();
  const [login, setLogin] = useState("");
  const [senha, setSenha] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleEnterButton = async () => {
    try {
      const response = await enterpriseAuth(login, senha);
      if (response.firstAccess) {
        setCnpj(login);
        navigate(SELECTEMAIL);
      } else {
        setCnpj(login);
        navigate(HOME_LOGGED);
      }
    } catch (err) {
      setError("Usuário ou senha inválidos.");
    }
  };

  const handleRegisterButton = () => {
    navigate(PREREGISTER)
  }

  return (
    <HomeStyle>
      <WrapContent>
        <SesiImageWrapper>
          <SesiImage src={SESI} />
          <VersionNumber>{version}</VersionNumber>
        </SesiImageWrapper>
        <h1>PORTAL DO CLIENTE</h1>
        <LoginCard>
          <WrapContentLoginCard>
            <h1>Faça seu login</h1>
            <LoginField
              placeholder="Login"
              value={login}
              onChange={(e) => setLogin(e.target.value)}
            />
            <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
              <LoginField
                type={showPassword ? "text" : "password"}
                placeholder="Senha"
                value={senha}
                onChange={(e) => setSenha(e.target.value)}
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: "absolute",
                  right: 10,
                  top: 10,
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                }}
              >
                {showPassword ? <FaEyeSlash size={20} /> : <FaEye size={20} />}
              </button>
            </div>
            {error && <p style={{ color: "red" }}>{error}</p>}
            <a href="/esqueci-senha">Esqueci minha senha</a>
            <EnterButton onClick={handleEnterButton}>Entrar</EnterButton>
            <h2>Não possui cadastro?</h2>
            <p onClick={handleRegisterButton}>Clique aqui e faça seu cadastro!</p>
          </WrapContentLoginCard>
        </LoginCard>
        {/* <a href={CREW_LOGIN}>
          <CrewImage src={CREW} />
        </a> */}
        <h2>Developed by WBC SISTEMAS</h2>
        <StaticImage src={BACKGROUNDIMAGE} />
      </WrapContent>
    </HomeStyle>
  );
}
